import { render, staticRenderFns } from "./AgentRequests.vue?vue&type=template&id=766c7abc"
import script from "./AgentRequests.vue?vue&type=script&lang=js"
export * from "./AgentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports